var map = {
	"./bug/apis.js": 181,
	"./lesson-scale/apis.js": 182,
	"./min-lesson/apis.js": 183,
	"./textbook/apis.js": 184
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 180;


//////////////////
// WEBPACK FOOTER
// ./src/modules (.*)\/apis\.js$
// module id = 180
// module chunks = 10